import { KeyboardEvent, MouseEvent, useCallback } from 'react';
import { ENTER_KEY } from 'common/constants/general';
import { markWorkboardSortHeaderForFocus } from 'dashboard409a/components/WorkboardSpreadsheet/WorkboardSortHeader';

type OnRequestSort = (event: MouseEvent<unknown>, property: string, addToSort?: boolean) => void;

// Datasheet keeps focus on `.data-grid-container` and eats Tab/Enter for cell nav,
// so sort headers rarely receive key events. Activate from the selected header cell.
const useWorkboardSortKeyDownCapture = (onRequestSort?: OnRequestSort) =>
  useCallback(
    (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key !== ENTER_KEY && event.key !== ' ') {
        return;
      }
      if (!onRequestSort) {
        return;
      }

      const target = event.target as HTMLElement | null;
      if (!target) {
        return;
      }

      const grid = target.closest('.data-grid-container');
      if (!grid) {
        return;
      }

      let sortButton = target.closest('[data-workboard-sort-header="true"]') as HTMLElement | null;
      let headerCell = sortButton?.closest('td') as HTMLTableCellElement | null;

      if (!sortButton) {
        headerCell = grid.querySelector('td.cell.selected.table-header') as HTMLTableCellElement | null;
        sortButton = headerCell?.querySelector('[data-workboard-sort-header="true"]') as HTMLElement | null;
      }

      if (!sortButton || !headerCell) {
        return;
      }

      const columnId = headerCell.getAttribute('data-column-ref');
      if (!columnId) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      const title = sortButton.getAttribute('data-workboard-sort-title');
      if (title) {
        markWorkboardSortHeaderForFocus(title);
      }

      onRequestSort(event as unknown as MouseEvent<unknown>, columnId, event.shiftKey);
    },
    [onRequestSort]
  );

export default useWorkboardSortKeyDownCapture;
